module.exports = __webpack_public_path__ + "static/media/DownloadExcel-01.869da3d1.svg";